import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({
  filters: {
    acronym (value:string) {
      if (!value) return
      const [firstname, lastname] = value.trim().split(' ')
      if (!lastname) return firstname.slice(0, 2)
      return `${firstname[0]}${lastname[0]}`
    }
  }
})
class BMUserProfileWidget extends Vue {
  @Prop({ default: () => ({}), type: [Object] })
  user: any;
  @Prop({ default: () => false, type: [Boolean] })
  hasWidth: boolean;

  constructor () {
    super()
  }

  get lblSetting () {
    return {
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get fullname () {
    if (!Object.keys(this.user).length) return ''
    return this.user.entity.fullname || `${this.user.entity.firstname} ${this.user.entity.lastname}`.trim()
  }

  get presence () {
    switch (this.user.presence) {
      case 'P': return this.$t(this.lblSetting.bmMeetingPresent)
      case 'A': return this.$t(this.lblSetting.bmMeetingAbsent)
      case 'E': return this.$t(this.lblSetting.bmMeetingCantBeHere)
    }
  }
  get summonNextMeeting () {
    if (this.user.summon_next_meeting) { return this.$t(this.lblSetting.summonNextMeeting) }
    return ''
  }
}

export default BMUserProfileWidget



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-user-profile-widget/index.ts